/**
 * 表单验证公共字段
 */
function isArray(arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
}

var mustFill = {
  required: true,
  validator: (rule, value, callback) => {
    if (value === null || value === undefined || value === '' || (isArray(value) && (value.length === 0))) {
      return callback(new Error('该字段为必填项'));
    } else {
      callback();
    }
  },
  trigger: 'change'
};

var mustNumber = {
  validator: (rule, value, callback) => {
    var reg = /^[0-9]*$/;
    if (!reg.test(value)) {
      return callback(new Error('输入内容只能为整数'));
    } else {
      callback();
    }
  },
  trigger: 'blur'
}
var mustNumberer = {
  validator: (rule, value, callback) => {
    var reg = /^[1-9]{1}\d*$/;
    if (!reg.test(value)) {
      return callback(new Error('输入内容只能为整数'));
    } else {
      callback();
    }
  },
  trigger: 'blur'
}
export {
  mustFill,
  mustNumber,
  mustNumberer
}